import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../../hooks/useAdminAuth';

export const AdminLayout = () => {
  const { admin, logout } = useAdminAuth();
  const location = useLocation();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: 'Dashboard', path: '/admin/dashboard' },
    { icon: 'ri-calendar-line', label: 'Agendamentos', path: '/admin/agendamentos' },
    { icon: 'ri-question-answer-line', label: 'Consultas', path: '/admin/consultas' },
    { icon: 'ri-money-euro-circle-line', label: 'Pagamentos', path: '/admin/pagamentos' },
    { icon: 'ri-article-line', label: 'Blog', path: '/admin/blog' },
    { icon: 'ri-image-line', label: 'Galeria', path: '/admin/galeria' },
    { icon: 'ri-settings-4-line', label: 'Configurações', path: '/admin/configuracoes' },
  ];

  const handleLogout = () => {
    if (confirm('Tem certeza que deseja sair?')) {
      logout();
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-blue-900 text-white flex flex-col fixed h-full">
        {/* Logo */}
        <div className="p-6 border-b border-blue-800">
          <Link to="/admin/dashboard" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
              <i className="ri-admin-line text-xl"></i>
            </div>
            <div>
              <h1 className="font-bold text-lg">FF Travel</h1>
              <p className="text-xs text-blue-300">Painel Admin</p>
            </div>
          </Link>
        </div>

        {/* Menu */}
        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                      isActive
                        ? 'bg-orange-500 text-white shadow-lg'
                        : 'text-blue-100 hover:bg-blue-800'
                    }`}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <span className="font-medium whitespace-nowrap">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* User Info */}
        <div className="p-4 border-t border-blue-800">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-blue-700 rounded-full flex items-center justify-center">
              <i className="ri-user-line text-lg"></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">{admin?.username}</p>
              <p className="text-xs text-blue-300 truncate">{admin?.email}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg transition-colors whitespace-nowrap"
          >
            <i className="ri-logout-box-line"></i>
            <span className="font-medium">Sair</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 ml-64">
        {/* Header */}
        <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
          <div className="px-8 py-4 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">
                {menuItems.find(item => item.path === location.pathname)?.label || 'Painel Administrativo'}
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                Bem-vindo, {admin?.username}
              </p>
            </div>
            <div className="flex items-center gap-4">
              <Link
                to="/"
                target="_blank"
                className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>Ver Site</span>
              </Link>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
